import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import CareersDetail from 'features/careers-detail/CareersDetail'
import type { CareersDetailProps } from 'features/careers-detail/types'
import { Localizations } from 'types/language'
import { routes } from 'utils/routes'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'

const CareersDetailPage = (props: CareersDetailProps) => {
  // Constants
  const { seo, title, heroImage } = props.jobOffer
  const SEO: SeoProps = {
    description: seo?.metaDescription,
    image: seo?.seoImage?.url ?? heroImage?.url,
    title: seo?.seoTitle ?? title
  }

  return (
    <Layout seo={SEO} localized={props.localizations}>
      <CareersDetail {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ params, locale }) => {
  // Get the slug from the URL
  const { slug } = params

  // Get the job offer by slug
  const jobOffer = await cmsLib.getJobOfferBySlug(slug, locale)

  if (!jobOffer) {
    return {
      notFound: true,
      revalidate: 5
    }
  }

  // Get the localizations
  const localizations = jobOffer.localizations?.reduce(
    (prev: Localizations, curr) => {
      if (!curr.publishedAt) return prev

      return {
        ...prev,
        [curr.locale]: routes(curr.locale, curr.slug).careerDetail
      }
    },
    { [locale]: routes(locale, slug).careerDetail }
  )

  return {
    props: {
      jobOffer,
      localizations,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'careers'], i18nConfig))
    }
  }
}

export const getStaticPaths = async () => {
  const jobOffers = await cmsLib.getJobOffers('all')

  const paths = jobOffers.map((jobOffer) => [{ locale: jobOffer.locale, params: { slug: jobOffer.slug } }]).flat()

  return {
    fallback: 'blocking',
    paths // will server-render pages on-demand if the path does not exist
  }
}

export default CareersDetailPage
